var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-cell"
  }, [(_vm.hasAttachments) ? _c('div', {
    staticClass: "uk-grid-small",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.attachments), function(attachment) {
    return _c('div', {
      staticClass: "uk-width-small"
    }, [_c('thumbnail', {
      attrs: {
        "attachment": attachment
      }
    })], 1)
  })) : _c('text-placeholder')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-effdffae","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/GalleryCell.vue
// module id = 2138
// module chunks = 0